import type { PurchaseOrder } from "../redistribution/models/PurchaseOrder.js";
import type { Sku } from "../redistribution/models/Sku.js";

/**
 * Deep clone an array of purchase orders including their SKUs
 * Used to create independent copies for algorithm execution
 * @param purchaseOrders - Original array of purchase orders
 * @returns New array with cloned purchase orders and skus
 */
export function clonePurchaseOrders(
  purchaseOrders: PurchaseOrder[]
): PurchaseOrder[] {
  return purchaseOrders.map(
    (po): PurchaseOrder => ({
      ...po,
      skus: po.skus.map((sku): Sku => ({ ...sku })),
    })
  );
}
